module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_022.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_022.png
// module id = 2369
// module chunks = 5